export const AdminUiAuditController = {
    index(): void {},
};
